import { MutationTree } from 'vuex';
import { IModalState, MODAL_MUTATION_TYPES } from './modal-types.store';

export const mutations: MutationTree<IModalState> = {
    [MODAL_MUTATION_TYPES.UPDATE_STATE_MODAL]: (state, payload) => {
        state.config = { ...payload.config };
    }
}